export const AUTHENTICATION = {
  TYPE: {
    NONE: 'None' as const,
    API_TOKEN: 'API token' as const,
    USERNAME_AND_PASSWORD: 'Username & password' as const,
  },

  ADD_TO: {
    HEADER: 'Header' as const,
    QUERY_PARAMS: 'Query params' as const,
  },

  API_TOKEN: {
    ADD_TO: 'Add to' as const,
    NAME: 'Name' as const,
    VALUE: 'Value' as const,
  },

  SHARED: {
    CREDENTIAL: 'Credential' as const,
  },

  // secret-store expects the auth type to be one of these
  REQUEST_TYPE: {
    BASIC: 'basic' as const,
    API_TOKEN: 'apiToken' as const,
    OAUTH: 'oAuth' as const,
  },
} as const;

export const REQUEST_VERBS = {
  POST: 'POST' as const,
  GET: 'GET' as const,
} as const;

export const MAX_EXPR_LENGTH = 100000;

export const FLOW_TRIGGER_EVENT_MODES = {
  test: 'test' as const,
  live: 'live' as const,
} as const;

export const LOGIC_BLOCK_CATEGORIES = {
  Actions: 'Actions' as const,
  Utilities: 'Utilities' as const,
  Triggers: 'Triggers' as const,
} as const;
